import format from 'date-fns/format'

export const serialiseDate = (date: Date) => format(date, 'YYYY-MM-DD')

/* eslint-disable sort-keys */
export const TIERS = {
  TIER_ONE: 1,
  TIER_THREE: 5,
  TIER_TWO: 2
}
/* eslint-disable sort-keys */
